/* Theoric · remove marca da oferta antiga Kaching (deal Hj9R) das linhas do carrinho. Roda 1x por sessão. NÃO APLICADO. */
(function () {
  var KEY = 'theoric_fix_hj9r_v1';
  try { if (sessionStorage.getItem(KEY)) return; sessionStorage.setItem(KEY, '1'); } catch (e) { return; }
  var end = new Date('2026-11-27T00:00:00-03:00');
  if (new Date() >= end) return;
  function isStale(it) {
    var p = it.properties || {}, raw = p.__kaching_bundles;
    if (!raw) return false;
    try { return JSON.parse(raw).deal === 'Hj9R'; } catch (e) { return String(raw).indexOf('Hj9R') > -1; }
  }
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  fetch('/cart.js', { headers: J }).then(function (r) { return r.json(); }).then(function (cart) {
    var stale = cart.items.filter(isStale);
    if (!stale.length) return;
    var updates = {}, readd = [];
    stale.forEach(function (it) {
      updates[it.key] = 0;
      var props = {};
      Object.keys(it.properties || {}).forEach(function (k) {
        if (k !== '__kaching_bundles' && k !== '__kaching_session_id') props[k] = it.properties[k];
      });
      readd.push({ id: it.variant_id, quantity: it.quantity, properties: props });
    });
    return fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: updates }) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: readd }) }); })
      .then(function (r) {
        if (!r.ok) throw r;
        document.dispatchEvent(new CustomEvent('theoric:cart-fixed'));
        if (/^\/cart/.test(location.pathname)) location.reload();
      });
  }).catch(function () { /* silencioso, sem retry para evitar loop */ });
})();
